import { motion, AnimatePresence } from "framer-motion";

const TransitionWipe = ({ active }) => (
  <AnimatePresence>
    {active && (
      <motion.div
        data-testid="page-transition-wipe"
        className="fixed inset-0 z-[95] flex items-center justify-center overflow-hidden bg-[#050505]"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0, filter: "blur(10px)" }}
        transition={{ duration: 0.45, ease: [0.65, 0, 0.35, 1] }}
      >
        <motion.div
          className="absolute inset-y-0 w-1/3 bg-gradient-to-r from-transparent via-white/[0.08] to-transparent"
          initial={{ x: "-150%" }}
          animate={{ x: "450%" }}
          transition={{ duration: 1.1, ease: [0.65, 0, 0.35, 1] }}
        />
        <motion.span
          className="font-display text-[11px] font-medium tracking-[0.55em] text-white/60"
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.4, ease: "easeOut" }}
        >
          CLOSER.
        </motion.span>
      </motion.div>
    )}
  </AnimatePresence>
);

export default TransitionWipe;
